import { Component, Directive, ElementRef, Input, OnInit, OnChanges } from '@angular/core';

import * as _ from 'lodash';

@Component({
  selector: 'uex-grid-item',
  template: '<ng-content></ng-content>'
})
export class GridItemComponent implements OnInit, OnChanges {
  @Input('settings') private _settings: GridItemSettings;

  @Input('cols') private _c: number | 'auto';
  @Input('col-xs') private _c_xs: number | 'auto';
  @Input('col-sm') private _c_sm: number | 'auto';
  @Input('col-md') private _c_md: number | 'auto';
  @Input('col-lg') private _c_lg: number | 'auto';
  @Input('col-xl') private _c_xl: number | 'auto';

  @Input('colXs') private __c_xs: number | 'auto';
  @Input('colSm') private __c_sm: number | 'auto';
  @Input('colMd') private __c_md: number | 'auto';
  @Input('colLg') private __c_lg: number | 'auto';
  @Input('colXl') private __c_xl: number | 'auto';

  @Input('offset') private _off: number;
  @Input('offset-xs') private _off_xs: number;
  @Input('offset-sm') private _off_sm: number;
  @Input('offset-md') private _off_md: number;
  @Input('offset-lg') private _off_lg: number;
  @Input('offset-xl') private _off_xl: number;

  @Input('offsetXs') private __off_xs: number;
  @Input('offsetSm') private __off_sm: number;
  @Input('offsetMd') private __off_md: number;
  @Input('offsetLg') private __off_lg: number;
  @Input('offsetXl') private __off_xl: number;

  @Input('order') private _ord: number;
  @Input('order-xs') private _ord_xs: number;
  @Input('order-sm') private _ord_sm: number;
  @Input('order-md') private _ord_md: number;
  @Input('order-lg') private _ord_lg: number;
  @Input('order-xl') private _ord_xl: number;

  @Input('orderXs') private __ord_xs: number;
  @Input('orderSm') private __ord_sm: number;
  @Input('orderMd') private __ord_md: number;
  @Input('orderLg') private __ord_lg: number;
  @Input('orderXl') private __ord_xl: number;

  constructor(
    public elementRef: ElementRef
  ) { }

  private _classes: string[] = [];

  private get _cols(): Cols {
    if (this._hasCols()) {
      return {
        xs: this._c_xs || this.__c_xs || 12,
        sm: this._c_sm || this.__c_sm || this._c,
        md: this._c_md || this.__c_md,
        lg: this._c_lg || this.__c_lg,
        xl: this._c_xl || this.__c_xl
      };
    } else {
      return null;
    }
  }

  private get _offsets(): Offsets {
    return {
      xs: this._off_xs || this.__off_xs || 0,
      sm: this._off_sm || this.__off_sm || this._off,
      md: this._off_md || this.__off_md,
      lg: this._off_lg || this.__off_lg,
      xl: this._off_xl || this.__off_xl
    };
  }

  private get _order(): Offsets {
    return {
      xs: this._ord_xs || this.__ord_xs || 0,
      sm: this._ord_sm || this.__ord_sm || this._ord,
      md: this._ord_md || this.__ord_md,
      lg: this._ord_lg || this.__ord_lg,
      xl: this._ord_xl || this.__ord_xl
    };
  }

  public ngOnInit() {
    this._updateClasses();
  }

  public ngOnChanges() {
    if (this._settings) {
      if (this._settings.cols) {
        if (_.isPlainObject(this._settings.cols)) {
          this._c = null;
          this._c_xs = (<Cols>this._settings.cols).xs;
          this._c_sm = (<Cols>this._settings.cols).sm;
          this._c_md = (<Cols>this._settings.cols).md;
          this._c_lg = (<Cols>this._settings.cols).lg;
          this._c_xl = (<Cols>this._settings.cols).xl;
        } else {
          this._c = (<number>this._settings.cols);
        }
      }

      if (this._settings.offset) {
        if (_.isPlainObject(this._settings.offset)) {
          this._off = null;
          this._off_xs = (<Offsets>this._settings.offset).xs;
          this._off_sm = (<Offsets>this._settings.offset).sm;
          this._off_md = (<Offsets>this._settings.offset).md;
          this._off_lg = (<Offsets>this._settings.offset).lg;
          this._off_xl = (<Offsets>this._settings.offset).xl;
        } else {
          this._off = (<number>this._settings.offset);
        }
      }

      if (this._settings.order) {
        if (_.isPlainObject(this._settings.order)) {
          this._off = null;
          this._off_xs = (<Orders>this._settings.order).xs;
          this._off_sm = (<Orders>this._settings.order).sm;
          this._off_md = (<Orders>this._settings.order).md;
          this._off_lg = (<Orders>this._settings.order).lg;
          this._off_xl = (<Orders>this._settings.order).xl;
        } else {
          this._off = (<number>this._settings.order);
        }
      }
    }

    this._updateClasses();
  }

  private _hasCols(): boolean {
    return  this._c >= 0 ||
            this._c_xs >= 0 || this.__c_xs >= 0 ||
            this._c_sm >= 0 || this.__c_sm >= 0 ||
            this._c_md >= 0 || this.__c_md >= 0 ||
            this._c_lg >= 0 || this.__c_lg >= 0 ||
            this._c_xl >= 0 || this.__c_xl >= 0
          ? true : false;
  }

  private _updateClasses() {
    this._clearClasses();

    this._classes.push('uex-grid-item');

    if (this._cols) {
      if (this._cols.xs) { this._classes.push(this._cols.xs === 'auto' ? 'col' : `col-${this._cols.xs}`); }
      if (this._cols.sm) { this._classes.push(`col-sm-${this._cols.sm}`); }
      if (this._cols.md) { this._classes.push(`col-md-${this._cols.md}`); }
      if (this._cols.lg) { this._classes.push(`col-lg-${this._cols.lg}`); }
      if (this._cols.xl) { this._classes.push(`col-xl-${this._cols.xl}`); }
    } else {
      this._classes.push('col');
    }

    if (this._offsets.xs) { this._classes.push(`offset-${this._offsets.xs}`); }
    if (this._offsets.sm) { this._classes.push(`offset-sm-${this._offsets.sm}`); }
    if (this._offsets.md) { this._classes.push(`offset-md-${this._offsets.md}`); }
    if (this._offsets.lg) { this._classes.push(`offset-lg-${this._offsets.lg}`); }
    if (this._offsets.xl) { this._classes.push(`offset-xl-${this._offsets.xl}`); }

    if (this._order.xs) { this._classes.push(`order-${this._order.xs}`); }
    if (this._order.sm) { this._classes.push(`order-sm-${this._order.sm}`); }
    if (this._order.md) { this._classes.push(`order-md-${this._order.md}`); }
    if (this._order.lg) { this._classes.push(`order-lg-${this._order.lg}`); }
    if (this._order.xl) { this._classes.push(`order-xl-${this._order.xl}`); }

    this._setClasses();
  }

  private _clearClasses() {
    if (this._classes) {
      const current_classes = this.elementRef.nativeElement.className.split(' ');
      this._classes.forEach((_class) => {
        const index = current_classes.indexOf(_class);
        if (index > -1) { current_classes.splice(index, 1); }
      });
      this._classes = [];
      this.elementRef.nativeElement.className = current_classes.join(' ');
    }
  }

  private _setClasses() {
    const current_classes = this.elementRef.nativeElement.className.split(' ').filter((i) => !!i);
    this.elementRef.nativeElement.className = _.concat(current_classes, this._classes).join(' ');
  }
}

@Directive({
  selector: '[uex-grid-item]'
})
export class GridItemDirective extends GridItemComponent { }

export interface GridItemSettings {
  cols?: number | Cols;
  rows?: number;
  offset?: number | Offsets;
  order?: number | Orders;
}

export interface Cols {
  xs: number | 'auto';
  sm: number | 'auto';
  md: number | 'auto';
  lg: number | 'auto';
  xl: number | 'auto';
}

export interface Offsets {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
}

export interface Orders extends Offsets {}
